













































import Vue from 'vue'
import { PaymentDTO } from '@/Application/Expediente'

export default Vue.extend({
  name: 'Payment',
  props: {
    pago: {
      type: PaymentDTO || null,
      required: false
    }
  },
  computed: {
    participacionPropiedad (): string {
      if (this.pago === null) {
        return ''
      }
      return this.pago.participacionPropiedad.toLocaleString('es-ES', { maximumFractionDigits: 4 })
    },
    participacionAdministracion (): string {
      if (this.pago === null) {
        return ''
      }
      return this.pago.participacionAdministracion.toLocaleString('es-ES', { maximumFractionDigits: 4 })
    }
  }
})
